export const subscriptionCancellationKeys = {
  all: ['subscriptionCancellation'] as const,
  situations: () => [...subscriptionCancellationKeys.all, 'situation'] as const,
  situation: () => [...subscriptionCancellationKeys.situations()] as const,
};
